import ConnectedAccountInfo from './ConnectedAccountInfo';

export default ConnectedAccountInfo;
